import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=c00a570c&scoped=true"
import script from "./NewDetail.vue?vue&type=script&lang=js"
export * from "./NewDetail.vue?vue&type=script&lang=js"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=c00a570c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a570c",
  null
  
)

export default component.exports